<template>
  <el-tabs type="border-card">
    <el-tab-pane label="所有车辆">
      <AllUserCar />
    </el-tab-pane>
    <el-tab-pane>
      <div class="pending_wrapper" slot="label">
        待审核车辆<span v-if="pendingNum > 0" class="pending_num"
          >({{ pendingNum }})</span
        >
      </div>
      <NeedCheckUserCar @fetchDataNum="fetchDataNum" />
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import AllUserCar from "./UserCarPage/AllUserCar";
import NeedCheckUserCar from "./UserCarPage/NeedCheckUserCar";

export default {
  name: "AgentPowerStation",
  components: { NeedCheckUserCar, AllUserCar },
  data() {
    return {
      pendingNum: 0,
    };
  },
  methods: {
    fetchDataNum(num) {
      this.pendingNum = num;
    },
  },
};
</script>

<style lang="scss">
.pending_wrapper {
  .pending_num {
    color: #ff0000;
    margin-left: 5px;
    font-weight: bold;
  }
}
</style>
